import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Delivery } from '../../types/Delivery';
import { DataFetchError } from '../../utils/ErrorClass';

export const useDelivery = () => {
  const [deliveries, setDeliveries] = useState<Delivery[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 100;

  const fetchDeliveries = useCallback(async (page: number) => {
    setLoading(true);
    const startIdx = (page - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage - 1;

    try {
      const { data, error, count } = await supabase
        .from('delivery')
        .select('*, customer(*)', { count: 'exact' }) // customerテーブルとのリレーションを取得
        .order('id', { ascending: false })
        .range(startIdx, endIdx);

      if (error) {
        throw new DataFetchError("データの取得失敗: " + error.message);
      }

      setDeliveries(data as Delivery[]);
      setTotalPages(Math.ceil((count ?? 0) / itemsPerPage));
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDeliveries(page);
  }, [page, fetchDeliveries]);

  return { deliveries, page, totalPages, setPage, fetchDeliveries, loading, error };
};
